import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import SearchPanel from "@widgets/SearchPanel";
import SnGrid from "@shared/components/GridV2/SnGrid";

interface Props {
  Menuprops: menuInfo;
}

// 외주발주진행현황
const SN_SAL_ISU_REP_018 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const params = {
        id: "sn_sct_por_rep_002_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
      });
    } catch (error: any) {}
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {},
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 flex flex-col gap-1.5 min-h-0">
        <div className="flex-1 min-h-200">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single" }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    </div>
  );
});

export default SN_SAL_ISU_REP_018;
